APP.tradeinUpdate = function () {
	const el = $('.tradein-update');
	const slickCarChoose = el.find('.slick--car-choose');

	const useCarModel = el.find('[name="model_key"]');
	const useCarModelLabel = useCarModel.data('label-model');
	const useCarModelPlaceholder = useCarModel.data('input-placeholder');

	const useCarYear = el.find('[name="year"]');
	const useCarYearLabel = useCarYear.data('label-model');
	const useCarYearPlaceholder = useCarYear.data('input-placeholder');

	const useCarVariant = el.find('[name="variant_key"]');
	const useCarVariantLabel = useCarVariant.data('label-model');
	const useCarVariantPlaceholder = useCarVariant.data('input-placeholder');

	const useCarOdo = el.find('[name="odo"]');
	const useCarOdoLabel = useCarOdo.data('label-model');
	const useCarOdoPlaceholder = useCarOdo.data('input-placeholder');

	const tradeinStepCarUse = el.find('.tradein-step--car-use');
	const tradeinStepResult = el.find('.tradein-step--result');
	const cesSummary = tradeinStepResult.find('.ces-summary');
	const cesSummaryPrice = cesSummary.find('.ces-summary__price');
	const cesSummaryModelKey = cesSummary.find('.ces-summary__model-key');
	const cesSummaryVariant = cesSummary.find('.ces-summary__variant');
	const cesSummaryYear = cesSummary.find('.ces-summary__year');
	const cesSummaryOdo = cesSummary.find('.ces-summary__odo');
	const cesSummaryImage = cesSummary.find('.ces-summary__image');
	const cesSummaryCopyLink = cesSummary.find('[name="copy-link"]');
	const cesSummaryBtnResell = cesSummary.find('.btn--resell');
	const cesSummaryBtnTradein = cesSummary.find('.btn--tradein');
	let newCarModelItem = {};
	let useCarModelItem = {};
	let noPrice = false;
	let isBackResell = false;

	const tradeinStepResell = el.find('.tradein-step--resell');
	const modelId = tradeinStepResell.find('[name="model_id"]');
	const selectVariantResell = tradeinStepResell.find('[name="variant_id"]');
	const selectVariantResellLabel = selectVariantResell.data('label-text');
	const selectVariantResellPlaceholder = selectVariantResell.data('input-placehoder');
	const titleResell = tradeinStepResell.find('.title-resell');
	const titleTextResell = titleResell.data('text-resell');
	const titleTextCompare = titleResell.data('text-compare');
	const btnResellNext = tradeinStepResell.find('.btn--resell-next');
	const btnResellNextText = btnResellNext.find('.btn__text');
	const btnTextResell = btnResellNext.data('text-resell');
	const btnTextCompare = btnResellNext.data('text--compare');

	const tradeinStepCompare = el.find('.tradein-step--compare');
	const btnNewResell = tradeinStepCompare.find('.btn--new-resell');
	const btnBackResell = tradeinStepCompare.find('.btn--back-resell');

	const tradeinStepUser = el.find('.tradein-step--user');
	const tradeinStepUserProvince = tradeinStepUser.find('[name="province"]');
	const tradeinStepUserProvinceLabel = tradeinStepUserProvince.data('label-text');
	const tradeinStepUserProvincePlaceholder = tradeinStepUserProvince.data('input-placeholder');
	const tradeinStepUserArea = tradeinStepUser.find('[name="registration_area"]');
	const tradeinStepUserAreaLabel = tradeinStepUserArea.data('label-text');
	const tradeinStepUserAreaPlaceholder = tradeinStepUserArea.data('input-placeholder');
	const btnSubmitInfo = tradeinStepUser.find('.btn--submit-info');
	const btnSubmitInfoText = btnSubmitInfo.find('.btn__text');
	const btnSubmitInfoResell = btnSubmitInfo.data('text-resell');
	const btnSubmitInfoTradein = btnSubmitInfo.data('text-tradein');

	const inputTradein = tradeinStepUser.find('[name="trade_in"]');
	const inputSaleUsedModel = tradeinStepUser.find('[name="sale_used_model"]');
	const inputUsedModel = tradeinStepUser.find('[name="used_model"]');
	const inputNewModel = tradeinStepUser.find('[name="new_model"]');
	const inputYearOfManufacture = tradeinStepUser.find('[name="year_of_manufacture"]');
	const inputOdometer = tradeinStepUser.find('[name="odometer"]');
	const inputDesireSell = tradeinStepUser.find('[name="desire_sell"]');

	const thankyou = $('.thank-you');

	const loading = el.find('.loading');

	let dataSubmit = {
		utm_source: getCookie('utm_source') ? getCookie('utm_source') : '',
		utm_content: getCookie('utm_content') ? getCookie('utm_content') : '',
		utm_medium: getCookie('utm_medium') ? getCookie('utm_medium') : '',
		utm_campaign: getCookie('utm_campaign') ? getCookie('utm_campaign') : '',
		mmv_campaign: getCookie('mmv_campaign') ? getCookie('mmv_campaign') : '',
	};

	const pModelKey = APP.getParameterByName('model_key');
	const pYear = APP.getParameterByName('year');
	const pVariantKey = APP.getParameterByName('variant_key');
	const pOdo = APP.getParameterByName('odo');

	function tracking(eventName, prop) {
		window.dataLayer = window.dataLayer || [];
		prop = prop || {};
		window.dataLayer.push({
			event: 'pangoTrack',
			eventAction: eventName,
			cdpData: {
				properties: prop,
			},
		});
		window.dataLayer.push({
			event: 'mmv-tracking',
			eventAction: eventName,
			prop: prop,
		});
	}

	function init() {
		if (el.length === 0) return;

		if (pModelKey && pYear && pVariantKey && pOdo) {
			loading.show();
			setTimeout(() => {
				const tradeinStepCarUsePos = tradeinStepCarUse.offset().top;
				APP.setScrollTopAnimation(tradeinStepCarUsePos);
			}, 500);
		}

		renderSelectProvince(
			tradeinStepUserProvince,
			tradeinStepUserProvinceLabel,
			tradeinStepUserProvincePlaceholder
		);
		renderSelectProvince(
			tradeinStepUserArea,
			tradeinStepUserAreaLabel,
			tradeinStepUserAreaPlaceholder
		);
		renderSelectUseCarModel(useCarModel, useCarModelLabel, useCarModelPlaceholder);
		renderSelectOdo(useCarOdo, useCarOdoLabel, useCarOdoPlaceholder);

		useCarModel.on('change', function () {
			const _this = $(this);
			const useCarModelValue = _this.val();
			const image = _this.find(':selected').attr('data-image');
			const modelName = _this.find(':selected').text();
			useCarModelItem = {
				image,
				modelName,
			};
			if (useCarModelValue) {
				useCarYear.removeAttr('disabled');
				renderSelectUseCarYear(
					useCarYear,
					useCarYearLabel,
					useCarYearPlaceholder,
					useCarModelValue
				);
			} else {
				useCarYear.attr('disabled', true);
				useCarVariant.attr('disabled', true);
				useCarOdo.val('').trigger('change');
				useCarOdo.attr('disabled', true);
				resetSelectUseCar(useCarYear, useCarYearLabel, useCarYearPlaceholder);
				resetSelectUseCar(useCarVariant, useCarVariantLabel, useCarVariantPlaceholder);
			}

			if (pYear) {
				useCarYear.val(pYear).trigger('change');
			}
		});

		useCarYear.on('change', function () {
			const _this = $(this);
			const useCarYearValue = _this.val();
			const useCarModelValue = useCarModel.val();
			if (useCarModelValue && useCarYearValue) {
				useCarModelItem = {
					...useCarModelItem,
					year: useCarYearValue,
				};
				useCarVariant.removeAttr('disabled');
				renderSelectUseCarVariant(
					useCarVariant,
					useCarVariantLabel,
					useCarVariantPlaceholder,
					useCarModelValue,
					useCarYearValue
				);
			} else {
				useCarVariant.attr('disabled', true);
				useCarOdo.val('').trigger('change');
				useCarOdo.attr('disabled', true);
				resetSelectUseCar(useCarVariant, useCarVariantLabel, useCarVariantPlaceholder);
			}
		});

		useCarVariant.on('change', function () {
			const _this = $(this);
			const value = _this.val();
			const variant = _this.find(':selected').text();
			useCarModelItem = {
				...useCarModelItem,
				variant,
			};

			if (value) {
				useCarOdo.removeAttr('disabled');
			} else {
				useCarOdo.val('').trigger('change');
				useCarOdo.attr('disabled', true);
			}
		});

		useCarOdo.on('change', function () {
			const _this = $(this);
			const odo = _this.val();
			const odoText = _this.find(':selected').text();
			useCarModelItem = {
				...useCarModelItem,
				odo,
				odoText,
			};
		});

		selectVariantResell.on('change', function () {
			const _this = $(this);
			const newVariantValue = _this.val();
			const newVariantName = _this.find(':selected').text();
			const newVariantImage = _this.find(':selected').attr('data-image');
			const newVariantPrice = _this.find(':selected').attr('data-price');
			newCarModelItem = {
				...newCarModelItem,
				newVariantValue,
				newVariantImage,
				newVariantPrice,
				newVariantName,
			};

			$('.car-new-model').html(newCarModelItem?.newCarModel);
			$('.car-new-variant').html(newVariantName);
			$('.car-new-price').html(APP.numberWithCommas(newVariantPrice));
			$('.car-new-image').attr('src', newVariantImage);
		});

		cesSummaryBtnResell.on('click', function () {
			tracking('RV_Sale');
			inputTradein.val(0);
			inputSaleUsedModel.val(1);
			inputYearOfManufacture.val(useCarModelItem?.year);
			inputOdometer.val(useCarModelItem?.odo);
			inputUsedModel.val(useCarModelItem?.model);
			inputDesireSell.val(useCarModelItem?.price);
			isBackResell = true;

			setTimeout(function () {
				inputDesireSell.mask('#,##0', { reverse: true });
				inputDesireSell.focus();
			}, 150);

			btnSubmitInfoText.html(btnSubmitInfoResell);
			tradeinStepResult.addClass(CLASS._blur);

			gsap.set(tradeinStepUser, {
				height: 'auto',
				alpha: 0,
			});
			gsap.to(tradeinStepUser, {
				duration: 0.4,
				alpha: 1,
				onComplete: function () {
					const tradeinStepUserPos = tradeinStepUser.offset().top;
					tradeinStepUser.addClass('tradin-step--show');
					APP.setScrollTopAnimation(tradeinStepUserPos);
				},
			});
		});

		cesSummaryBtnTradein.on('click', function () {
			tracking('RV_Trade_in');
			inputTradein.val(1);
			inputSaleUsedModel.val(0);
			inputYearOfManufacture.val(useCarModelItem?.year);
			inputOdometer.val(useCarModelItem?.odo);
			inputUsedModel.val(useCarModelItem?.model);
			inputDesireSell.val(useCarModelItem?.price);
			isBackResell = false;

			setTimeout(function () {
				inputDesireSell.focus();
				inputDesireSell.mask('#,##0', { reverse: true });
			}, 150);

			btnSubmitInfoText.html(btnSubmitInfoTradein);
			tradeinStepResult.addClass(CLASS._blur);

			if (!noPrice) {
				titleResell.html(titleTextCompare);
				btnResellNextText.html(btnTextCompare);
			} else {
				titleResell.html(titleTextResell);
				btnResellNextText.html(btnTextResell);
			}

			tradeinStepUser.removeClass('tradin-step--show');

			gsap.set(tradeinStepResell, {
				height: 'auto',
				alpha: 0,
			});

			gsap.to(tradeinStepResell, {
				duration: 0.4,
				alpha: 1,
				onComplete: function () {
					const tradeinStepResellPos = tradeinStepResell.offset().top;
					tradeinStepResell.addClass('tradin-step--show');
					APP.setScrollTopAnimation(tradeinStepResellPos);
				},
			});
		});

		$('.btn--back-step1').on('click', function () {
			tracking('RV_Back_Select​');
			tradeinStepCarUse.removeClass(CLASS._blur);
			const tradeinStepCarUsePos = tradeinStepCarUse.offset().top - $('.header').height();
			APP.setScrollTopAnimation(tradeinStepCarUsePos);
			setTimeout(() => {
				gsap.set(tradeinStepResult, {
					height: 0,
					alpha: 0,
				});
			}, 1000);
		});

		$('.btn--back-step2').on('click', function () {
			tracking('RV_Back_Select​');

			tradeinStepResult.removeClass(CLASS._blur);
			const tradeinStepResultPos = tradeinStepResult.offset().top - $('.header').height();
			APP.setScrollTopAnimation(tradeinStepResultPos);

			setTimeout(() => {
				gsap.set(tradeinStepResell, {
					height: 0,
					alpha: 0,
				});
			}, 1000);
		});

		$('.btn--back-step3').on('click', function () {
			tracking('RV_Back_Select​');

			if (isBackResell) {
				tradeinStepResult.removeClass(CLASS._blur);
				const tradeinStepResultPos = tradeinStepResult.offset().top - $('.header').height();
				APP.setScrollTopAnimation(tradeinStepResultPos);
			} else {
				tradeinStepCompare.removeClass(CLASS._blur);
				const tradeinStepComparePos = tradeinStepCompare.offset().top - $('.header').height();
				APP.setScrollTopAnimation(tradeinStepComparePos);
			}

			setTimeout(() => {
				gsap.set(tradeinStepUser, {
					height: 0,
					alpha: 0,
				});
			}, 1000);
		});

		btnBackResell.on('click', function () {
			tracking('RV_Back_Select​');
			tradeinStepResell.removeClass(CLASS._blur);
			const tradeinStepResellPos = tradeinStepResell.offset().top - $('.header').height();
			APP.setScrollTopAnimation(tradeinStepResellPos);
			setTimeout(() => {
				gsap.set(tradeinStepCompare, {
					height: 0,
					alpha: 0,
				});
			}, 1000);
		});

		btnNewResell.on('click', function () {
			tracking('RV_Register_Trade_in');
			inputNewModel.val(newCarModelItem?.newCarModel);

			setTimeout(function () {
				inputDesireSell.mask('#,##0', { reverse: true });
			}, 150);

			tradeinStepCompare.addClass(CLASS._blur);

			gsap.set(tradeinStepUser, {
				height: 'auto',
				alpha: 0,
			});

			gsap.to(tradeinStepUser, {
				duration: 0.4,
				alpha: 1,
				onComplete: function () {
					const tradeinStepUserPos = tradeinStepUser.offset().top;
					tradeinStepUser.addClass('tradin-step--show');
					APP.setScrollTopAnimation(tradeinStepUserPos);
				},
			});
		});

		APP.validate('.form--car-use', {
			isAjax: true,
			onComplete: function (res) {
				loading.show();

				grecaptcha.ready(function () {
					grecaptcha
						.execute('6LcCEBgnAAAAAJ_0NFiVTQSlpDYZ35ypza8kH-Qv', { action: 'submit' })
						.then(function (token) {
							const data = { ...res, g_token: token };

							tradeinStepCarUse.addClass(CLASS._blur);

							fetch(`${api}/rvCalculation`, {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
									lang: _lang,
								},
								body: JSON.stringify(data),
							})
								.then((res) => res.json())
								.then((data) => {
									loading.hide();
									tracking('RV_calc');
									if (data.result === 'success') {
										const { link, model, model_key, odo, price, variant, variant_key, year } =
											data?.item;

										noPrice = false;

										useCarModelItem = {
											...useCarModelItem,
											link,
											model,
											model_key,
											odo,
											price,
											variant,
											variant_key,
											year,
										};

										if (price) cesSummaryPrice.html(APP.numberWithCommas(price) + ' VNĐ');
										if (useCarModelItem?.modelName)
											cesSummaryModelKey.html(useCarModelItem?.modelName);
										if (variant) cesSummaryVariant.html(variant);
										if (year) cesSummaryYear.html(year);
										if (useCarModelItem?.odoText) cesSummaryOdo.html(useCarModelItem?.odoText);
										if (link) cesSummaryCopyLink.val(link);
										if (useCarModelItem?.image) cesSummaryImage.attr('src', useCarModelItem?.image);

										$('.car-use-model').html(useCarModelItem?.modelName);
										$('.car-use-variant').html(variant);
										$('.car-use-year').html(year);
										$('.car-use-odo').html(useCarModelItem?.odoText);
										$('.car-use-price').html(APP.numberWithCommas(price) + ' VNĐ');
										$('.car-use-image').attr('src', useCarModelItem?.image);
										$('.no-price').hide();
										$('.yes-price').show();
										$('.copy-wrapper').show();
									} else {
										noPrice = true;
										$('.yes-price').hide();
										$('.copy-wrapper').hide();
										$('.no-price').show();

										if (useCarModelItem?.modelName)
											cesSummaryModelKey.html(useCarModelItem?.modelName);
										if (useCarModelItem?.variant) cesSummaryVariant.html(useCarModelItem?.variant);
										if (useCarModelItem?.year) cesSummaryYear.html(useCarModelItem?.year);
										if (useCarModelItem?.odo) cesSummaryOdo.html(useCarModelItem?.odoText);
										if (useCarModelItem?.image) cesSummaryImage.attr('src', useCarModelItem?.image);
									}

									gsap.set(tradeinStepResult, {
										height: 'auto',
										alpha: 0,
									});

									gsap.to(tradeinStepResult, {
										duration: 0.4,
										alpha: 1,
										onComplete: function () {
											const tradeinStepResultPos = tradeinStepResult.offset().top;
											tradeinStepResult.addClass('tradin-step--show');
											APP.setScrollTopAnimation(tradeinStepResultPos);
										},
									});
								})
								.catch((error) => {
									console.log(error);
								});
						})
						.catch(function () {
							loading.hide();
						});
				});
			},
		});

		APP.validate('.form--resell', {
			isAjax: true,
			onComplete: function () {
				tradeinStepResell.addClass(CLASS._blur);
				tracking('RV_Select_New');
				if (!noPrice) {
					const priceMore = newCarModelItem?.newVariantPrice - useCarModelItem?.price;
					$('.price-more__number').html(APP.numberWithCommas(priceMore) + ' VNĐ');

					gsap.set(tradeinStepCompare, {
						height: 'auto',
						alpha: 0,
					});

					gsap.to(tradeinStepCompare, {
						duration: 0.4,
						alpha: 1,
						onComplete: function () {
							const tradeinStepComparePos = tradeinStepCompare.offset().top;
							tradeinStepCompare.addClass('tradin-step--show');
							APP.setScrollTopAnimation(tradeinStepComparePos);
						},
					});
				} else {
					gsap.set(tradeinStepUser, {
						height: 'auto',
						alpha: 0,
					});

					gsap.to(tradeinStepUser, {
						duration: 0.4,
						alpha: 1,
						onComplete: function () {
							const tradeinStepUserPos = tradeinStepUser.offset().top;
							tradeinStepUser.addClass('tradin-step--show');
							APP.setScrollTopAnimation(tradeinStepUserPos);
						},
					});
				}
			},
		});

		APP.validate('.form--user', {
			isAjax: true,
			onComplete: function (res) {
				dataSubmit = {
					...dataSubmit,
					...res,
					desire_sell: res.desire_sell.replace(/,/g, ''),
				};

				loading.show();

				fetch(`${api}/form/tradeIn`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						lang: _lang,
					},
					body: JSON.stringify(dataSubmit),
				})
					.then((res) => res.json())
					.then((data) => {
						loading.hide();
						if (data.result === 'success') {
							// CDP
							const company = [];
							if (dataSubmit.new_model) company.push(dataSubmit.new_model);
							if (dataSubmit.mmv_campaign) company.push(dataSubmit.mmv_campaign);
							else company.push(dataSubmit.trade_in === '1' ? 'Trade-in' : 'Bán xe');
							tracking(dataSubmit.trade_in === '1' ? 'RV_Complete_Trade_in' : 'RV_Complete_Sale');
							dataLayer.push({
								event: 'pangoTrack',
								eventAction: 'generate_lead',
								label: '',
								user_data: {
									email_address: dataSubmit.email,
									phone_number: dataSubmit.phone,
									address: {
										first_name: dataSubmit.name,
									},
								},
								cdpData: {
									properties: {
										fullname: dataSubmit.name,
										email: dataSubmit.email,
										phone: dataSubmit.phone,
										manufacture: dataSubmit.manufacturer,
										versionVehicle: dataSubmit.used_model,
										yearManufacture: dataSubmit.year_of_manufacture,
										numberODO: dataSubmit.odometer,
										useFor: dataSubmit.trade_in !== '1' ? 'resell' : 'buyoldrenew',
										placeOfRegist: dataSubmit.registration_area,
										livingArea: dataSubmit.province,
										desiredSell: parseInt(dataSubmit.desire_sell.replace(/,/g, '')),
										isTradeIn: true,
										listTagsModel: dataSubmit.new_model,
										listTagsCampaign:
											dataSubmit.mmv_campaign || dataSubmit.trade_in === '1'
												? 'Trade-in'
												: 'Bán xe',
										company: company.join(','),
										// position: 'tradein',
									},
								},
							});

							tradeinStepUser.addClass(CLASS._blur);

							gsap.set(thankyou, {
								display: 'block',
								alpha: 0,
							});

							gsap.to(thankyou, {
								duration: 0.4,
								alpha: 1,
								onComplete: function () {
									const thankyouPos = thankyou.offset().top;
									thankyou.addClass('tradin-step--show');
									APP.setScrollTopAnimation(thankyouPos);
								},
							});
						}
					})
					.catch((error) => {
						loading.hide();
						console.log(error);
					});
			},
		});

		slickCarChoose.slick({
			infinite: true,
			centerMode: true,
			centerPadding: '180px',
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						infinite: true,
						centerMode: true,
						centerPadding: '60px',
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		slickCarChoose.on('swipe', function () {
			handleCarChoose();
		});

		slickCarChoose.on('click', '.slick-active', onClickSlickItem);

		$('.summary__copy button').on('click', function (evt) {
			evt.preventDefault();
			copyToClipboard();
		});
	}

	function copyToClipboard() {
		$('.summary__copy input').select();
		document.execCommand('copy');
	}

	function onClickSlickItem(e) {
		e.stopPropagation();
		const index = $(this).data('slick-index');
		slickCarChoose.slick('slickGoTo', index);
		handleCarChoose();
	}

	function handleCarChoose() {
		const slickSlide = slickCarChoose.find('.slick-slide');
		const formGroup = slickCarChoose.next();
		const formError = formGroup.find('.form__error');
		const slickActiveCenter = slickCarChoose.find('.slick-active.slick-center');
		const title = slickActiveCenter.find('.title');
		const modelIdValue = parseInt(title.data('model-id'));
		const modelNameValue = title.text();
		slickSlide.removeClass(CLASS._selected);
		slickActiveCenter.addClass(CLASS._selected);
		formGroup.removeClass(CLASS._error).removeClass(CLASS._focus);
		formError.text('');
		modelId.val(modelIdValue);
		newCarModelItem = {
			newCarModel: modelNameValue,
		};

		renderSelectVariant(
			selectVariantResell,
			selectVariantResellLabel,
			selectVariantResellPlaceholder,
			modelIdValue
		);
	}

	function renderSelectVariant(selectEl, optText, inputPlaceholder, modelIdValue) {
		APP.getData(`${api}/wp/variant?model_id=${modelIdValue}`, function (data) {
			let options = `<option value="">${optText}</option>`;
			data?.items?.map(
				(item) =>
					(options += `<option value="${item?.slug}" data-image="${item?.image_thumbnail}" data-price="${item?.acf?.price}">${item?.title}</option>`)
			);
			APP.renderSelect(selectEl, options, inputPlaceholder);
		});
	}

	function renderSelectUseCarModel(selectEl, optText, inputPlaceholder) {
		let checkModelKey = null;
		APP.getData(`${api}/rvCalculation/model`, function (data) {
			let options = `<option value="">${optText}</option>`;
			if (data?.result === 'success') {
				checkModelKey = data?.items.find((item) => item?.model_key === pModelKey);
				data?.items.map(
					(item) =>
						(options += `<option value="${item?.model_key}" data-image="${item?.image_thumbnail}">${item?.name}</option>`)
				);
				APP.renderSelect(selectEl, options, inputPlaceholder);
				if (pModelKey && checkModelKey) {
					selectEl.val(pModelKey).trigger('change');
				}
			}
		});
	}

	function renderSelectUseCarYear(selectEl, optText, inputPlaceholder, modelKey) {
		let checkYear = null;
		APP.getData(`${api}/rvCalculation/year?model_key=${modelKey}`, function (data) {
			let options = `<option value="">${optText}</option>`;
			if (data?.result === 'success') {
				checkYear = data?.items.find((item) => item?.year === parseInt(pYear));
				data?.items.map(
					(item) => (options += `<option value="${item?.year}">${item?.year}</option>`)
				);

				APP.renderSelect(selectEl, options, inputPlaceholder);
				if (pYear && checkYear) {
					selectEl.val(pYear).trigger('change');
				}
			}
		});
	}

	function renderSelectUseCarVariant(selectEl, optText, inputPlaceholder, modelKey, year) {
		let checkVariant = null;
		APP.getData(`${api}/rvCalculation/variant?model_key=${modelKey}&year=${year}`, (data) => {
			let options = `<option value="">${optText}</option>`;
			if (data?.result === 'success') {
				checkVariant = data?.items.find((item) => item?.variant_key === pVariantKey);
				data?.items.map(
					(item) => (options += `<option value="${item?.variant_key}">${item?.variant}</option>`)
				);

				APP.renderSelect(selectEl, options, inputPlaceholder);
				if (pVariantKey && checkVariant) {
					selectEl.val(pVariantKey).trigger('change');
					setTimeout(() => {
						$('.btn--car-use').trigger('click');
					}, 3000);
				}
			}
		});
	}

	function renderSelectOdo(selectEl, optText, inputPlaceholder) {
		//let checkOdo = null;
		APP.getData(`${api}/rvCalculation/odo`, (data) => {
			let options = `<option value="">${optText}</option>`;

			if (data?.result === 'success') {
				//checkOdo = data?.items.find((item) => item?.odo_value === pOdo);
				data?.items.map(
					(item) => (options += `<option value="${item?.odo_value}">${item?.odo_name}</option>`)
				);

				APP.renderSelect(selectEl, options, inputPlaceholder);

				if (pOdo) {
					selectEl.val(pOdo).trigger('change');
				}
				$('.img--icon').attr('src', data?.compare_icon);
				$('.no-price__note').html(data?.description_rv_summary_1);
				$('.compare-car__note').html(data?.description_rv_summary_2);
			}
		});
	}

	function resetSelectUseCar(selectEl, optText, inputPlaceholder) {
		let options = `<option value="">${optText}</option>`;
		APP.renderSelect(selectEl, options, inputPlaceholder);
	}

	function renderSelectProvince(selectEl, optText, inputPlaceholder) {
		let options = `<option value="">${optText}</option>`;
		APP.getData(`${api}/general/province`, function (data) {
			data.items
				.map((province) => {
					options += `<option data-province-id="${province.province_id}" value="${province.name}">${province.name}</option>`;
				})
				.join('');
			APP.renderSelect(selectEl, options, inputPlaceholder);
		});
	}

	init();
};
